import { render, staticRenderFns } from "./AddFiltersDialog.vue?vue&type=template&id=9f335072&scoped=true"
import script from "./AddFiltersDialog.vue?vue&type=script&lang=js"
export * from "./AddFiltersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f335072",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f335072')) {
      api.createRecord('9f335072', component.options)
    } else {
      api.reload('9f335072', component.options)
    }
    module.hot.accept("./AddFiltersDialog.vue?vue&type=template&id=9f335072&scoped=true", function () {
      api.rerender('9f335072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentGroupDialog/AddFiltersDialog.vue"
export default component.exports